import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'app-construction-key-library',
    templateUrl: './construction-key-library.component.html',
    styleUrls: ['./construction-key-library.component.scss'],
    standalone: false
})
export class ConstructionKeyLibraryComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}
}
